import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/internal/Observable";
import { BranchRequestModel } from "@model/branch.model";
import { GenericApiResponseModel, ResponseModel } from "@model/api.model";
import { FpxGenerateRequestModel, HlbGetTokenRequestModel } from "@model/payment.mode";


@Injectable({
    providedIn: "root",
})
export class PaymentApiService {

    constructor(
        private http: HttpClient
        ) {
    }
    
    getMbbQr(referenceNumber: string): Observable<any> {
        return this.http.post<ResponseModel<GenericApiResponseModel<any>>>(
            '/payment/mbb/GetQR/'+referenceNumber, ''
        );
    }

    getMbbQrTransactionStatus(referenceNumber: string): Observable<any> {
        return this.http.get<ResponseModel<GenericApiResponseModel<any>>>(
            '/payment/mbb/GetTransactionStatus/'+referenceNumber
        );
    }

    getHlbToken(model: HlbGetTokenRequestModel): Observable<ResponseModel<GenericApiResponseModel<any>>> {
         return this.http.post<ResponseModel<GenericApiResponseModel<any>>>(
            '/payment/hlb/getToken', model
        );
    }

    
    getFpxBankList(): Observable<any> {
        return this.http.get<ResponseModel<GenericApiResponseModel<any>>>(
            '/payment/fpx/GetBankList/'
        );
    }
    
    generateFpxRequest(model: FpxGenerateRequestModel): Observable<any> {
         return this.http.post<ResponseModel<GenericApiResponseModel<any>>>(
            '/payment/fpx/generateRequest', model
        );
    }
}
